var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArgenCoIconHouseRgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 357.2 425.2",
    style: {
      enableBackground: "new 0 0 357.2 425.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#145459;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161,5.8c10.4-7.7,24.7-7.7,35.1,0l148.7,110.4c7.1,5.3,12.3,13.6,12.3,22.4V397c0,15.6-12.6,28.2-28.1,28.2 H28.1C12.6,425.2,0,412.6,0,397V138.6c0-8.8,5.2-17.2,12.3-22.4L161,5.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArgenCoIconHouseRgb);
export default __webpack_public_path__ + "static/media/ArgenCo_icon_house_rgb.8a6fade909786c45e4b48567baba0ead.svg";
export { ForwardRef as ReactComponent };